import React from "react";
import { RCCButton, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import SortableHandle from "src/components/Sortable/Handle";
import { ILineDashboardComponent } from "./interface";
import { Column, Lines } from "./styles";
import ColumnContent from "./columnContent";

type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

const Line: React.FC<ILineDashboardComponent> = ({
	rows,
	isEditing,
	id,
	deleteLineDashboard,
	cards,
	callbackChangeCard,
	deleteCard
}) => {
	const { translate } = useTranslation();
	const arrRows = Array.from(Array(rows).keys());
	const width = Math.floor(12/rows);
	const internalCards = cards ? cards.map((card) => ({
		...card,
		id: card.daa002Id.toString()
	})): [];

	return (
		<Lines style={isEditing ? { minHeight: "220px" } : {}}>
			{arrRows.map((row, index) => (
				<Column 
					key={`dashboard-lines-${row}`}
					container
					item
					xs={12}
					sm={rows % 2 !== 0 ? 12 : 6}
					md={width as GridSize}
					style={isEditing ? { border: "1px dashed var(--border-color)"} : {}}
				>
					<ColumnContent 
						id={id}
						index={index}
						callbackChangeCard={callbackChangeCard}
						deleteCard={deleteCard}
						isEditing={isEditing}
						internalCard={internalCards.find((x) => x.daa002Coluna === index)}
					/>
				</Column>
			))}
			{isEditing && (
				<div className="trashFixed">
					<SortableHandle>
						<RCCTooltip 
							text={translate("Mover")}
						>
							<RCCButton
								icon={{
									name: "arrows", 
									color: "var(--grey)", 
									size: 14
								}}
								color="transparent"
								layout="isRounded"
								size="xs"
							/>
						</RCCTooltip>	
					</SortableHandle>
					<RCCTooltip
						text={translate("Excluir")}
						color="red"
					>
						<RCCButton
							icon={{
								name: "trash",
								color: "var(--red)"
							}} 
							color="transparent"
							onClick={() => deleteLineDashboard(id)}
						/>
					</RCCTooltip>
				</div>
			)}
		</Lines>
	);
};

export default Line;
